<template>
  <div class="page-add">
    <div class="add-title">其他集中培训审核详情</div>
    <div class="audit_detail">
      <div class="param_item">
        <div class="required">学员姓名：</div>
        <div>{{ detailForm.userName }}</div>
      </div>
      <div class="param_item">
        <div class="required">工作单位：</div>
        <div>{{ detailForm.deptName }}</div>
      </div>
      <div class="param_item">
        <div class="required">单位及职务：</div>
        <div>{{ detailForm.unitPosition }}</div>
      </div>
      <div class="param_item">
        <div class="required">培训名称：</div>
        <div>{{ detailForm.lectureName }}</div>
      </div>
      <div class="param_item">
        <div class="required">培训时间：</div>
        <div>{{ detailForm.trainTimeStr }}</div>
      </div>
      <div class="param_item">
        <div class="required">学时（小时）：</div>
        <div>{{ detailForm.lectureHours }}</div>
      </div>
      <div class="param_item">
        <div class="required">培训地点：</div>
        <div class="desc-right">{{ detailForm.lecturePlace }}</div>
      </div>
      <div class="param_item">
        <div class="required">培训单位：</div>
        <div class="desc-right">{{ detailForm.organizer }}</div>
      </div>
      <div class="param_item" v-if="detailForm.attachmentList && detailForm.attachmentList.length > 0">
        <div class="required">培训内容：</div>
        <div >
          {{ detailForm.attachmentList[0].name }}
          <span
            :class="[isImage ? 'file_style' : 'unClick_style']"
            @click.stop="showImgPreview"
            >预览</span
          >
          <span class="file_style" @click="downloadFile">下载</span>
        </div>
      </div>
      <div class="param_item" v-if="detailForm.sitePhotosList && detailForm.sitePhotosList.length > 0">
        <div class="required">现场照片：</div>
        <div  class="photos_style">
          <av-preview
            v-for="(item, i) in detailForm.sitePhotosList"
            :key="'photo' + i"
            :src="item.url"
            type="image"
          />
        </div>
      </div>
    </div>
    <div class="top_title">
      <span>审核进度</span>
    </div>
    <div class="block">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in detailForm.classAuditHistories"
          :key="index"
          :icon="activity.auditSchedule !== 8 ? 'el-icon-circle-check': ''"
          :type="activity.auditSchedule !== 8 ? 'primary': ''"
          :color="activity.color"
          :size="'large'"
        >
        <div v-if="activity.auditSchedule !== 8">
            <span class="audit-user">
              <div>{{ activity.auditUserName }}</div>
              <div class="m-l-10">{{ activity.deptName }}</div>
            </span>

            <div class="margin-top-10">
              {{
                activity.auditDate == null
                  ? ""
                  : activity.auditDate +
                    (activity.auditContent
                      ? "\u3000" + activity.auditContent
                      : "")
              }}
            </div>
            <DealAttachment
              class="margin-top-10"
              v-if="
                activity.auditAttachmentName !== undefined &&
                  activity.auditAttachmentName
              "
              :isPreview="
                isImageType(
                  activity.auditAttachmentName.substr(
                    activity.auditAttachmentName.lastIndexOf('.') + 1
                  )
                )
              "
              :name="activity.auditAttachmentName"
              :url="JSON.parse(activity.auditAttachment)[0].url"
            />
            <div
              class="margin-top-10"
              v-if="
                (activity.auditSchedule === 7 ||
                  activity.auditSchedule === 2) &&
                  activity.classPushStatusName !== undefined
              "
            >
              <span>{{
                activity.historyPushTime + "  " + activity.classPushStatusName
              }}</span>
              <!-- <span class="deal-span" @click="asyncAgain(activity.uuid)"
              >再次同步</span
            > -->
            </div>
          </div>
          <div v-else>
            <div
              v-for="(item, j) in activity.auditUserNameList"
              :key="'auditUserNameList' + j"
              class="audit_item"
            >
              <span>{{ item }}</span>
              <span class="status_style">{{ activity.auditContent }}</span>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>

    <div slot="footer" class="dialog-footer">
      <butn size="medium" @click="goBack" btntype title="返回"></butn>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="bigImgList"
    />
  </div>
</template>

<script>
// 审核
import butn from "@/components/button/index";
import { queryOtherTrainDeclareInfo } from "@/api/topicLecture";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import DealAttachment from "@/views/leaveAudit/dealAttachment.vue";
import AvPreview from "@/components/av-preview/index";

export default {
  name: "otherTrainDeclareDetail",
  components: { butn, ElImageViewer, DealAttachment, AvPreview },
  data() {
    return {
      size: "small",
      detailForm: {},
      detailId: null,
      showViewer: false,
      bigImgList: [],
      isImage: false,
      showCover: false
    };
  },
  created() {
    this.detailId = this.$route.query.id;
    // 获取审核详情
    this.queryDeclareDetail();
  },
  methods: {
    goBack() {
      this.$router.push('/otherTrainDeclare');
    },
    // 获取请假审核详情
    queryDeclareDetail() {
      queryOtherTrainDeclareInfo(this.detailId).then((res) => {
        if (res && res.code == 0) {
          this.detailForm = res.data;
          this.detailForm.sitePhotosList = res.data.sitePhotos ? JSON.parse(res.data.sitePhotos) : [];
          this.detailForm.attachmentList = res.data.attachment ? JSON.parse(res.data.attachment) : [];
          // 判断资源类型
          const attachmentName = this.detailForm.attachmentList.length > 0 ? this.detailForm.attachmentList[0].name : null;
          if (attachmentName) {
            const urlIndex = attachmentName.lastIndexOf(".");
            let ext = attachmentName.substr(urlIndex + 1);
            this.isImage = this.isImageType(ext);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //附件下载
    downloadFile() {
      if (this.detailForm.attachmentList.length > 0) {
        fetch(this.detailForm.attachmentList[0].url)
          .then((res) => res.blob())
          .then((blob) => {
            // 将链接地址字符内容转变成blob地址
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = this.detailForm.attachmentList[0].name;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          });
      } else {
        this.$message.warning('下载内容为空')
      }
    },
    // 查看大图
    showImgPreview() {
      if (!this.isImage) {
        return;
      }
      this.showViewer = true;
      let attachment = JSON.parse(this.detailForm.attachment);
      this.bigImgList = [attachment[0].url];
    },
    // 判断文件类型：图片
    isImageType(ext) {
      return (
        ["png", "jpg", "jpeg", "gif", "svg"].indexOf(ext.toLowerCase()) !== -1
      );
    },
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
/deep/ #video-cover {
  width: 208px;
  height: 128px;
  margin-right: 16px;
  .avatar {
    width: 100%;
    height: 100%;
  }
  .el-icon-delete {
    cursor: not-allowed !important;
  }
}
.audit_detail {
  font-size: 14px;
  color: #343c4a;
  padding: 10px 24px 52px 24px;
  .param_item {
    display: flex;
    line-height: 42px;
  }
  .required {
    width: 110px;
    text-align: right;
  }
  .desc-right {
    width: calc(100% - 100px);
  }
  .file_style {
    color: #3a85ff;
    cursor: pointer;
    margin-left: 16px;
  }
  .unClick_style {
    color: #96a1b2;
    cursor: not-allowed;
    margin-left: 16px;
  }
  div.required:before {
    content: "* ";
    color: red;
  }
}
.width_100 {
  width: 100px;
}
.top_title {
  padding: 0 16px;
  margin-bottom: 32px;
  height: 42px;
  line-height: 42px;
  background-color: #efefef;
  color: #333333;
  font-weight: bold;
  font-size: 14px;
}
.form-text-center {
  text-align: center !important;
}
.dialog-footer {
  margin-top: 24px;
  text-align: center;
}
.deal-span {
  cursor: pointer;
  color: #3a85ff;
  margin-left: 10px;
}
.margin-top-10 {
  margin-top: 10px;
}
.audit-user {
  display: flex;
}
.m-l-10 {
  margin-left: 16px;
}
.photos_style {
  display: flex;
}
.audit_item {
  margin-bottom: 10px;
  .status_style {
    color: #F97016;
    margin-left: 16px;
  }
}
</style>
